import { render, staticRenderFns } from "./DictSelect.vue?vue&type=template&id=1c5d1332&scoped=true"
import script from "./DictSelect.vue?vue&type=script&lang=js"
export * from "./DictSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d1332",
  null
  
)

export default component.exports